export default {
  title: 'Datos de envío',
  buttons: {
    save: 'Guardar',
  },
};
